import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setToken(data.access_token);
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        nav(data.role === "admin" ? "/admin" : data.role === "transport_partner" ? "/partner" : "/dashboard");
      } catch {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return <div className="min-h-screen flex items-center justify-center text-slate-400">Anmeldung wird abgeschlossen…</div>;
}
